var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reservation-list-item-button-change"},[_c('button',{staticClass:"reservation-list-item-button-change-class",attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"reservation-list-item-button-change-text"},[_vm._v(_vm._s(_vm.$t('parts.reservationChange')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }